import React, { useState } from "react";

export default function Step2({ formData, updateFormData, nextStep, prevStep }) {
  const [errors, setErrors] = useState({});

  const handleNext = () => {
    const newErrors = {};
    if (!formData?.passportFront) newErrors.passportFront = "Обязательное поле";
    if (!formData?.passportBack) newErrors.passportBack = "Обязательное поле";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      nextStep();
    }
  };

  return (
    <div className="form-inner">
      <h2 className="form-title">KYC – Паспорт (передняя и обратная сторона)</h2>

      <div className="upload-container-main">
        {/* Блок Передняя сторона */}
        <div className="upload-item-box">
          <span className="upload-label">Передняя сторона паспорта</span>
          <label className="btn-upload-action">
            <span className="icon-box">📥</span> Загрузить
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                updateFormData({ passportFront: e.target.files[0] });
                setErrors({ ...errors, passportFront: "" });
              }}
            />
          </label>
          {formData?.passportFront && (
            <div className="file-ready-badge">✅ {formData.passportFront.name}</div>
          )}
          {errors.passportFront && <span className="error-hint">{errors.passportFront}</span>}
        </div>

        {/* Блок Обратная сторона */}
        <div className="upload-item-box">
          <span className="upload-label">Обратная сторона паспорта</span>
          <label className="btn-upload-action">
            <span className="icon-box">📥</span> Загрузить
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                updateFormData({ passportBack: e.target.files[0] });
                setErrors({ ...errors, passportBack: "" });
              }}
            />
          </label>
          {formData?.passportBack && (
            <div className="file-ready-badge">✅ {formData.passportBack.name}</div>
          )}
          {errors.passportBack && <span className="error-hint">{errors.passportBack}</span>}
        </div>
      </div>

      {/* Нижняя панель: Шаг слева, кнопки справа */}
      <div className="form-footer-right">
        <span className="step-text">Шаг: 2/3</span>
        <div className="nav-buttons-group">
          <button className="btn-back-white" onClick={prevStep}>
            ← Назад
          </button>
          <button className="btn-next-main" onClick={handleNext}>
            Далее →
          </button>
        </div>
      </div>
    </div>
  );
}